import { toggleAmazonChatVisibility } from "@/shared/lib/amazon-connect";
import { useSettingsStore } from "@/shared/stores";

export const useAmazonChat = () => {
  const isAmazonChatOpen = useSettingsStore((state) => state.isAmazonChatOpen);
  const setIsAmazonChatOpen = useSettingsStore(
    (state) => state.setIsAmazonChatOpen,
  );

  const showChat = () => {
    toggleAmazonChatVisibility(true);
    setIsAmazonChatOpen(true);
  };

  const hideChat = () => {
    toggleAmazonChatVisibility(false);
    setIsAmazonChatOpen(false);
  };

  const toggleChatVisibility = () => {
    toggleAmazonChatVisibility(!isAmazonChatOpen);
    setIsAmazonChatOpen(!isAmazonChatOpen);
  };

  return {
    actions: { showChat, hideChat, toggleChatVisibility },
  };
};
